import styled from 'styled-components';
import { DragIndicator } from '@10d/tend-ui-icons/DragIndicator';
import { Toggle as Toggle$1 } from '../../../../primitives/Toggle/Toggle.js';

const Toggle = styled(Toggle$1) `
  width: 100%;
`;
styled(DragIndicator) `
  cursor: grab;
`;

export { Toggle };
